import type { WorkspaceToolParamView } from '../contracts/tool-view';

const ADVANCED_PARAMETER_IDS = new Set([
  'seed',
  'steps',
  'guidance',
  'guidance_scale',
  'prompt_strength',
]);

/**
 * Adapt workspace controls for display without changing the model's field
 * contract, provider value, defaults or parameter mappings.
 */
export function presentWorkspaceParameter(
  field: WorkspaceToolParamView
): WorkspaceToolParamView {
  const group = ADVANCED_PARAMETER_IDS.has(field.id) ? 'advanced' : field.group;

  if (
    field.id !== 'steps' ||
    (field.type !== 'slider' && field.type !== 'number') ||
    typeof field.min !== 'number' ||
    typeof field.max !== 'number' ||
    typeof field.step !== 'number' ||
    !Number.isFinite(field.min) ||
    !Number.isFinite(field.max) ||
    !Number.isFinite(field.step) ||
    field.step <= 0 ||
    field.max < field.min
  ) {
    return { ...field, group };
  }

  const count = Math.floor((field.max - field.min) / field.step + 1e-9) + 1;
  // Keep very large/unbounded ranges in their original numeric control.
  if (count < 1 || count > 512) {
    return { ...field, group };
  }

  const options = Array.from({ length: count }, (_, index) => {
    const value = Number((field.min! + index * field.step!).toFixed(10));
    return {
      value,
      label: String(value),
      accessPolicy: field.accessPolicy,
      requiredPaid: field.requiredPaid,
      disabled: false,
    };
  });

  return { ...field, group, type: 'select', options };
}
